import { render, staticRenderFns } from "./AccordionGuide.vue?vue&type=template&id=632222ca&"
import script from "./AccordionGuide.vue?vue&type=script&lang=js&"
export * from "./AccordionGuide.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports